module.exports = __webpack_public_path__ + "static/img/line.fad87b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/line.jpg
// module id = 2LfC
// module chunks = 0